import { render, staticRenderFns } from "./dialog-card.vue?vue&type=template&id=35fd92b6&scoped=true"
import script from "./dialog-card.vue?vue&type=script&lang=js"
export * from "./dialog-card.vue?vue&type=script&lang=js"
import style0 from "./dialog-card.vue?vue&type=style&index=0&id=35fd92b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fd92b6",
  null
  
)

export default component.exports